import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AppRoutes } from './enums/Approutes';
import Login from './pages/login/Login';
import ResetPassword from './pages/resetPassword/ResetPassword';
import SetNewPassword from './pages/resetPassword/SetNewPassword';
import PinMap from './pages/pinMap/PinMap';
import Settings from './pages/settings/Settings';
import PrivateRoute from './routes/PrivateRoute';
import Pinners from './pages/pinners/Pinners';
import Consultancy from './pages/consultancy/Consultancy';
import NotFound from './pages/404/NotFound';
import WelcomePage from './pages/welcome/WelcomePage';
import ProfilePage from './pages/profile/ProfilePage';
import OnBoarding from './pages/onBoarding/OnBoarding';
import Notifications from './pages/notifications/Notifications';
import { AuthProvider } from './hooks/authContext';
import { GlobalDataProvider } from './hooks/globalDataContext';
import { MarkerProvider } from './hooks/useMarker';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AuthLoader from './hooks/authLoader';
import Feedback from './pages/feedback/Feedback';
import { GoogleOAuthProvider } from '@react-oauth/google';
import Terms from './pages/policy/Terms';
import Policy from './pages/policy/Policy';
import Chat from './pages/ai-chat/Chat';
import Layout from './components/specific/layout/Layout';
import Referral from './pages/referral/Referral';
import Billing from './pages/billing/Billing';
import BillingSuccess from './pages/billing/BillingSuccess';
import BillingFailed from './pages/billing/BillingFailed';
import PinnerProProfilePage from './pages/profile/PinnerProProfilePage';
import { getConfig } from './config/env';

const App = () => {
  const googleClient = getConfig().GOOGLE_CLIENT_ID;

  return (
    <GoogleOAuthProvider clientId={googleClient}>
      <AuthProvider>
        <GlobalDataProvider>
          <MarkerProvider>
            <Router>
              <ToastContainer />
              <AuthLoader>
                {/* Public Routes */}
                <Routes>
                  <Route path={AppRoutes.LOGIN} element={<Login />} />
                  <Route path={AppRoutes.LOGIN_WITH_REFERRAL} element={<Login />} />
                  <Route path={AppRoutes.SIGNUP} element={<Login />} />
                  <Route path={AppRoutes.SIGNUP_WITH_REFERRAL} element={<Login />} />
                  <Route path={AppRoutes.RESET_PASSWORD} element={<ResetPassword />} />
                  <Route path={AppRoutes.SET_NEW_PASSWORD} element={<SetNewPassword />} />
                  <Route path={AppRoutes.WELCOME} element={<WelcomePage />} />
                  <Route path={AppRoutes.ON_BOARDING} element={<OnBoarding />} />
                  <Route path={AppRoutes.PROFILE} element={<ProfilePage />} />
                  <Route path={AppRoutes.TERMS} element={<Terms />} />
                  <Route path={AppRoutes.PRIVACY} element={<Policy />} />
                  <Route path="*" element={<NotFound />} />

                  {/* Private Routes */}
                  <Route element={<PrivateRoute />}>
                    <Route element={<Layout />}>
                      <Route path="/" element={<PinMap />} />
                      <Route path={AppRoutes.FEEDBACK} element={<Feedback />} />
                      <Route path={AppRoutes.SETTINGS} element={<Settings />} />
                      <Route path={AppRoutes.NOTIFICATIONS} element={<Notifications />} />
                      <Route path={AppRoutes.PINNERS} element={<Pinners />} />
                      <Route path={AppRoutes.PINNER_PRO_PROFILE} element={<PinnerProProfilePage />} />
                      <Route path={AppRoutes.CHAT} element={<Chat />} />
                      <Route path={AppRoutes.CONSULTANCY} element={<Consultancy />} />
                      <Route path={AppRoutes.REFERRAL} element={<Referral />} />
                      <Route path={AppRoutes.BILLING} element={<Billing />} />
                      <Route path={AppRoutes.BILLING_SUCCESS} element={<BillingSuccess />} />
                      <Route path={AppRoutes.BILLING_CANCELED} element={<BillingFailed />} />
                    </Route>
                  </Route>
                </Routes>
              </AuthLoader>
            </Router>
          </MarkerProvider>
        </GlobalDataProvider>
      </AuthProvider>
    </GoogleOAuthProvider>
  )
}

export default App